import { call, fork, select, take, takeEvery } from 'redux-saga/effects';

import history from '../history'

import { fetchEfector, updateEfector as sendUpdate, createEfector as sendCreate, resendLoginMailEfector, api } from '../api'

import { efectorActions } from './actions';
import { getEfectorById } from './selectors';

import { Popup } from '../../components/common/Popup';


export function* loadEfector(datos) {

  const { efectorId } = datos.payload;
  const efector = yield select(getEfectorById, efectorId);
  if (efector) {
    //verificar el tiempo que paso desde que se obtuvo los datos del efector, si paso mas de 15 minutos se vuelve a pedir
    const current_date = new Date();
    const interval = current_date.getTime() - efector.created_at.getTime();
    const elapsed_time =  Math.round(interval/(1000 * 60 * 15));

    if ( !efector.isPending && ( efector.isNew || elapsed_time) ){
      yield call(fetchEfector, efectorId);
    }
  }

}

export function* updateEfector({payload}) {
  const { efectorId, efector } = payload;
  yield call(sendUpdate, efectorId, efector);
}


export function* createEfector({payload}) {
  const { efector, efectorId } = payload;
  yield call(sendCreate, efectorId, efector);
}

export function* deleteEfector({payload}) {
  const { efectorId } = payload;
  yield call(api.deleteEfector, efectorId);
}

export function* resendLoginMail({payload}) {
    const { efectorId } = payload;
    const res = yield call(api.resendLoginMailEfector, efectorId);
    console.log('response-> ', res);
  }

//=====================================
//  WATCHERS
//-------------------------------------

export function* watchLoadEfector() {
  yield takeEvery(efectorActions.LOAD_EFECTOR, loadEfector);
}

export function* watchUpdateEfector() {
  yield takeEvery(efectorActions.UPDATE_EFECTOR, updateEfector);
}


export function* watchCreateEfector() {
  yield takeEvery(efectorActions.CREATE_EFECTOR, createEfector);
}

export function* watchDeleteEfector() {
  yield takeEvery(efectorActions.DELETE_EFECTOR, deleteEfector);
}


export function* watchNavigateToEfector() {
  while (true) {
    const { payload } = yield take(efectorActions.NAVIGATE_TO_EFECTOR);
    yield history.push(payload);
  }
}

export function* watchResendLoginMail() {
    yield takeEvery(efectorActions.RESEND_LOGIN_MAIL, resendLoginMail);
}

//=====================================
//  ROOT
//-------------------------------------

export const efectorSagas = [
  fork(watchLoadEfector),
  fork(watchNavigateToEfector),
  fork(watchUpdateEfector),
  fork(watchCreateEfector),
  fork(watchDeleteEfector),
  fork(watchResendLoginMail),
];
